import SeoHead from '../../components/SeoHead';
import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import TextWithCTA from '../../components/TextWithCTA';
import Clients from '../../components/Clients';
import ImageWithText from '../../components/ImageWithText';
import OurBranches from '../../components/OurBranches';
import OurValues from '../../components/OurValues';
import WhyDrivingForce from '../../components/WhyDrivingForce';
import TwoColumns from '../../components/TwoColumns';
import EyeSvg from '/public/site-assets/svg/eye.svg';
import MountainSvg from '/public/site-assets/svg/mountain.svg';
import Header from '../../components/MainHeader';
import SimplePage from '../../components/SimplePage';
import MailchimpWidget from '../../components/MailchimpWidget';

export default function Employers({
    global,
    all_clients,
    all_employerTag
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Who we are | Gap Personnel`}
                // description={`Driving Force Recruitment are a complete business infrastructure with impressive resource & scale. Read all about our driving recruitment history.`}
                canonical_link={`/who-we-are/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`employers_page.sub_banner`}
                customClass={`mb-5 primary-banner `}
                buttonTitle={`Employers`}
                buttonLink={``}
                heading={`Who we are`}
                bannerImage="/site-assets/images/who-we-are-new.jpg"
                bannerImageAlt="Employer Banner"
            />
            <TextWithCTA
                global={global}
                pathPrefix={`employers_page.text_with_cta`}
                customClass={`mt-5 mb-5`}
                link1={`/job-seekers-get-in-touch`}
                link2={`/recruit-staff/`}
                column1={false}
                column2={true}
                buttonTitle1={
                    <>
                        <strong>
                            Get a callback
                        </strong> and we'll help you find your next role
                    </>
                }
                buttonTitle2={
                    <>
                        <strong>
                            Recruit staff
                        </strong> let us help your fill your next role
                    </>
                }
                fullWidth={true}
                mainButtonTitle2={`Get in touch`}
                mainButtonLink2={`/recruit-staff/`}
            />
            <ImageWithText
                global={global}
                pathPrefix={`employers_page.image_with_text`}
                customClass={`my-md-5 pb-5`}
                content={
                    <>
                        <h2 className='mb-4'>Hello, and welcome to Driving Force Recruitment!</h2>
                        <p>Whilst we’re not ones for making it all about us, we understand that you might want to know a little bit about who we are before deciding whether we’re the right fit for your business.</p>
                        <p>So, if you’re after a quick intro have a watch of the video below to find out how we’ve grown, from the original specialist division of our parent company, gap personnel group, from supporting our colleagues in Flint to the national specialist driving provider we are today.</p>
                    </>
                }
                imageUrl={`/site-assets/images/employer-introduction-image.jpg`}
                imageAlt={`Employer Introduction`}
                label={`Watch how we can help you`}
                videoLink={`https://www.canva.com/design/DAGRq0D6gYQ/SO9LQ-n3Bma_HxPhItULIw/watch?embed`}
                video_category={`employer-video`}
            />
            <TwoColumns
                global={global}
                pathPrefix={`employers_page.two_columns`}
                customClass='my-md-5 pb-5'
                heading='We’re established, we’re experienced, we’re financially stable.'
                subheading={
                    <>
                        <p>But we know that might not be enough for you to choose us. But knowing what drives our business just might be…</p>
                    </>}
                content1={
                    <>

                        <h5>Vision</h5>
                        <p>By delivering unmatched dedication to customer service and satisfaction we will become the first-choice destination for drivers and customers seeking a trusted recruitment partner</p>
                    </>
                }
                content2={
                    <>
                        <div className='mb-4 icon'>
                            <span className='d-inline-block p-3'> <MountainSvg /></span>
                        </div>
                        <h5>Mission</h5>
                        <p>To be the driving force behind speedy and compliant recruitment solutions with a personalised approach through nurturing long-term relationships with all of our people</p>
                    </>
                }
            />
            <OurValues
                global={global}
                pathPrefix={`employers_page.our_values`}
                customClass='mt-lg-5 mb-5 py-lg-5 five-columns'
                sub_heading_1={`Driven to deliver`}
                sub_heading_2={`Focused on solutions`}
                sub_heading_3={`Respectful relationships`}
                sub_heading_4={`Real`}
                sub_heading_5={`Ethical`}
                content_1={`Our dedicated teams are geared up to deliver quality and always go the extra mile. We never settle for complacency, constantly challenging ourselves to bring that first-class service you deserve.`}
                content_2={`Meeting your needs is our priority. We’ll listen and use our industry experience to provide objective advice and a personal service, putting you in the driving seat.`}
                content_3={`Having a reliable, trustworthy agency is key to successful collaboration and achieving common goals. Let’s enjoy the journey together, and build a genuine working relationship based on mutual respect and open communication.`}
                content_4={`We are not faceless; we’re people who work on a national basis across a range of sectors, all towards a common goal. Let’s have real conversations about needs and how we can help.`}
                content_5={`We offer peace of mind through ethical and compliant practices, for clients, candidates, and employees.`}
                heading={`Our Values`}
                imageSrc1={`/site-assets/images/innovative-icon.jpg`}
                imageSrc2={`/site-assets/images/consultative-icon.jpg`}
                imageSrc3={`/site-assets/images/accountable-icon.jpg`}
                imageSrc4={`/site-assets/images/real-icon.jpg`}
                imageSrc5={`/site-assets/images/ethical-icon.jpg`}
                imageAlt1={`Our value 1`}
                imageAlt2={`Our value 2`}
                imageAlt3={`Our value 3`}
                imageAlt4={`Our value 4`}
                imageAlt5={`Our value 5`}
                displayOnDefault={true}
            />
            <Clients
                global={global}
                pathPrefix={`employers_page.all_clients`}
                all_clients={all_clients}
                customClass={`pt-lg-5 mt-lg-5`}
                heading={`Accreditations and partnerships`}
            />
            {/* <SimplePage
                global={global}
                pathPrefix={`employers_page.simple_page`}
                customClass={`mt-5 pt-5 mb-5 pb-5 pb-md-0`}
                content={
                    <>
                        <h2>Talk to us about Driver CPC training</h2>
                        <p>We’re a fully qualified driving school able to support drivers through their initial and ongoing periodic training. You can find out more <Link href="/employers-specialisms/cpc-training/"><a className
                            ="text-decoration-none">here</a></Link>.</p>
                    </>
                }
                textCenter={true}
            /> */}
            <WhyDrivingForce
                global={global}
                pathPrefix={`employers_page.why_driving_force`}
                customClass='mt-5 mb-5 pt-lg-5 pb-5'
                formId={`2b1903d0-c09a-4b34-9c3b-27a7b7afb573`}
                heading={`Why they choose Driving Force`}
                all_testimonials={all_employerTag}
                subheading={`Get in touch`}
            />
            <OurBranches
                global={global}
                pathPrefix={`employers_page.our_branches`}
                customClass='mt-5 mb-5 pb-5'
                heading={`Our branches`}
                content={`
                Operating from one of our five regional branches across England, our consultants are on hand to offer tailored support and local knowledge for all your driver recruitment needs.
                `}
                buttonTitle={`Our locations`}
                buttonLink={`/employers-get-in-touch/`}
            />
            <MailchimpWidget />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const clients = await Collection('accreditations');
    const all_clients = clients.orderBy('order').getItems();

    const employerTag = "Employers";
    const employer_tag_testimonial = (await Collection('testimonials'))
        .filter(function (post) {
            return (
                post.tag?.en === employerTag
            );
        })
    const all_employerTag = employer_tag_testimonial.orderBy('order').getItems();

    return {
        props: {
            global,
            all_clients,
            all_employerTag
        },
    }
}